import { RootState } from '@/storage/store.ts'
import BasicSettings from './components/BasicSettings.tsx'
import PersonalInfo from './components/PersonalInfo.tsx'
import UserPrograms from './components/UserPrograms.tsx'
import { useSelector } from 'react-redux'
import { useEffect, useRef } from 'react'
import { LogUserActivity } from '@/apis/users/requests.ts'
import { LOG_TYPES } from '@/common/constants.ts'
import TwoFaSettings from './components/TwoFaSettings.tsx'
// import { AuthenticateUser } from '../../../storage/user/authSlice'

export default function UsersProfileView() {
  const user = useSelector((state: RootState) => state.auth.user)

  const UserData = {
    id: user?.id ?? 0,
    status: user?.status ?? 1,
    global_country_id: user?.global_country_id ?? 3,
    global_state_id: user?.global_state_id ?? 1,
    username: '',
    first_name: user?.first_name ?? '',
    last_name: user?.last_name ?? '',
    phone: user?.phone ?? '',
    email: user?.email ?? '',
    city: user?.city ?? '',
    profile_picture: user?.profile_picture ?? '',
    language_preference_id: user?.language_preference_id ?? 0,
    global_timezone_id: user?.global_timezone_id ?? 0,
  }

  const hasLoggedPageView = useRef(false)
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'My Profile',
      }) // Log page view
      hasLoggedPageView.current = true // Mark as executed
    }
  }, [])

  return (
    <div className="container-fixed flex grow gap-5 lg:gap-7.5">
      {/* Sidebar Component */}
      {/* <Sidebar /> */}

      {/* Main Content */}
      <div className="flex flex-col items-stretch grow gap-5 lg:gap-7.5">
        <PersonalInfo {...UserData} callBackUrl={''} />
        <BasicSettings {...UserData} />
        <TwoFaSettings phone={UserData.phone} id={UserData.id} />
        <UserPrograms userId={user?.id} />
      </div>
    </div>
  )
}
